import { render, staticRenderFns } from "./AppLabelFileupload.vue?vue&type=template&id=04389f42&scoped=true&"
import script from "./AppLabelFileupload.vue?vue&type=script&lang=js&"
export * from "./AppLabelFileupload.vue?vue&type=script&lang=js&"
import style0 from "./AppLabelFileupload.vue?vue&type=style&index=0&id=04389f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04389f42",
  null
  
)

export default component.exports